import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import Reg from "../../common/Reg";

export class VirPublicParam {
  companyId = 0;
  title = "";
  text = "";
  textForApi = "";
  spd = 50;
}

export class VirMp3Param extends VirPublicParam {
  audioFormat = "mp3";
}

export class VirMp4Param extends VirPublicParam {
  location = "0";
  bgUrl =
    "https://oss.hina.com/app/test/2021/01/14/6042fb1b274f551e0d1de36823775623.png";
  bgAudioUrl = "";
  bgAudioVol = "1";
  videoFormat = "mp4";
  ratio = "480";
  width = ""; // 横竖屏-视频宽度，数值需要为4的倍数
  height = ""; // 横竖屏-视频高度，数值需要为4的倍数
  wh = ""; // 视频比例，新增的额外字段，方便获取 width 和 height
  quality = "0";
  subtitles = "0";

  public rules(): _.Dictionary<object[]> {
    return {
      title: [
        {
          required: true,
          message: "请输入视频标题",
          trigger: ["change", "blur"]
        }
      ],
      text: [
        {
          required: true,
          message: "请输入需要配音的文本",
          trigger: ["blur", "change"]
        }
      ],
      spd: [
        {
          validator: (rule: unknown, value: string, callback: Function) => {
            if (parseInt(value) > 100 || parseInt(value) < 1) {
              return callback(new Error("请输入1-100的数字"));
            } else {
              return callback();
            }
          },
          trigger: ["blur", "change"]
        }
      ]
    };
  }
}

export class VirPinyinParam {
  text = "";
}

export class VirSaveImgParam {
  companyId = 0;
  url = "";
}

export class ListCommonParam {
  page = 1;
  pageSize = 10;
}

export class VirListParam extends ListCommonParam {
  companyId = 0;
  titleLike = "";
  textLike = "";
  virType = "mp4";
  virStatusList: number[] = [];
}

export class VirGetParam {
  companyId = 0;
  virId = 0;
}

export class VirImgDelParam {
  companyId = 0;
  imgId = 0;
}

export class VirImgListParam {
  imgId = 0;
  url = "";
}

export class VirImgList {
  count = 0;
  page = 1;
  pageSize = 20;
  pageMax = 1;
  imgList: VirImgListParam[] = [];
}

export class VirListImgParam extends ListCommonParam {
  companyId = 0;
}

export default class VirRequest extends Model {
  // 创建音频
  static virCreateMp3(virMp3Param: VirMp3Param) {
    return request.post("/aiExam/vir/newMp3", virMp3Param).then(resp => {
      return resp.data;
    });
  }

  // 创建视频
  static virCreateMp4(virMp4Param: VirMp4Param) {
    return request.post("/aiExam/vir/newMp4", virMp4Param).then(resp => {
      return resp.data;
    });
  }

  // 拼音查询(多音字)
  static virPinyinMatch(virPinyinParam: VirPinyinParam) {
    return request.post("/aiExam/vir/pinyin", virPinyinParam).then(resp => {
      return resp.data;
    });
  }

  // 保存图片信息
  static virSaveImg(virSaveImgParam: VirSaveImgParam) {
    return request.post("/aiExam/vir/saveImg", virSaveImgParam).then(resp => {
      return resp.data;
    });
  }

  // 音频试听
  static virTestMp3(virMp3Param: VirMp3Param) {
    return request.post("/aiExam/vir/testMp3", virMp3Param).then(resp => {
      return resp.data;
    });
  }

  // 图片信息列表查询
  static virListImg(virListImgParam: VirListImgParam) {
    return request.post("/aiExam/vir/listImg", virListImgParam).then(resp => {
      return resp.data;
    });
  }

  // vir视频库 列表查询
  static virList(virListParam: VirListParam) {
    return request.post("/aiExam/vir/list", virListParam).then(resp => {
      return resp.data;
    });
  }

  // vir视频库 详情查询
  static virGet(virGetParam: VirGetParam) {
    return request.post("/aiExam/vir/get", virGetParam).then(resp => {
      return resp.data;
    });
  }

  // vir视频库 删除图片信息
  static virDeleteImg(virImgDelParam: VirImgDelParam) {
    return request.post("/aiExam/vir/deleteImg", virImgDelParam).then(resp => {
      return resp.data;
    });
  }

  // vir视频库 删除
  static virDelete(virGetParam: VirGetParam) {
    return request.post("/aiExam/vir/delete", virGetParam).then(resp => {
      return resp.data;
    });
  }

  // vir视频库 复制
  static virCopy(virGetParam: VirGetParam) {
    return request.post("/aiExam/vir/copy", virGetParam).then(resp => {
      return resp.data;
    });
  }
}
